import {combineReducers, configureStore} from '@reduxjs/toolkit';
import userSlice from './slice/userSlice';
import storage from 'redux-persist/lib/storage';
import {persistReducer, persistStore} from 'redux-persist';
import assignUserSlice from './slice/AssignUsersSlice';
import bulkUsersSlice from './slice/bulkUsersSlice';
import authenticatedUserSlice from './slice/authenticatedUserSlice';
import domainDataSlice from './slice/domainDataSlice';

import projectFormSlice from './slice/projectFormSlice';
import roleImpersonationSlice from './slice/roleImpersonationSlice';
import codingFormSlice from './slice/codingFormSlice';
import productionSlice from './slice/productionSlice';
import docViewSlice from './slice/docViewSlice';
import actionButtonSlice from './slice/actionButtonSlice';
import docListSlice from './slice/docListSlice';
import assignmentSlice from './slice/assignmentSlice';
import optimizedSortSlice from './slice/optimizedSortSlice';
import signalrSlice from './slice/signalrSlice';
import {signalRMiddleware} from './middleware/signalrMiddleware';
import sessionSearchSlice from './slice/sessionSearchSlice';
import batchPrintSlice from './slice/batchPrintSlice';
import tallyReportSlice from './slice/tallyReportSlice';
import exportDataSlice from './slice/ExportDataSlice';
import timelineGapReportSlice from './slice/timelineGapReportSlice';
import comExplorer from './slice/comExplorerSlice';
import categorization from './slice/categorizationSlice';
import actionMenuDataSlice from './slice/actionMenuUerRights';
import savedSearchSlice from './slice/savedSearchSlice';
import aiReviewReducer from './slice/aiReviewSlice';
import aiReviewV2Reducer from './slice/aiReviewSliceV2';
import createCustomIndexSlice from './slice/createCustomIndexSlice';
import selectAnalyzerSlice from './slice/selectAnalyzer';
import uiSlice from './slice/uiSlice';
import reproductionSlice from './slice/reproductionSlice';
import analyticsSlice from './slice/analyticsSlice';
import communicationExplorerSlice from './slice/communicationExplorerSlice';

const appReducer = combineReducers({
  user: userSlice,
  assignUser: assignUserSlice,
  domainData: domainDataSlice,
  bulkUser: bulkUsersSlice,
  authenticatedUser: authenticatedUserSlice,
  roleImpersonation: roleImpersonationSlice,
  projectForm: projectFormSlice,
  codingForm: codingFormSlice,
  production: productionSlice,
  docView: docViewSlice,
  actionButton: actionButtonSlice,
  docList: docListSlice,
  assignment: assignmentSlice,
  optimizesSort: optimizedSortSlice,
  signalr: signalrSlice,
  sessionSearch: sessionSearchSlice,
  batchPrint: batchPrintSlice,
  tallyreport: tallyReportSlice,
  exportData: exportDataSlice,
  timelineGapReport: timelineGapReportSlice,
  comExplorer: comExplorer,
  categorization: categorization,
  actionmenu: actionMenuDataSlice,
  savedSearch: savedSearchSlice,
  aiReview: aiReviewReducer,
  aiReviewV2: aiReviewV2Reducer,
  indexManagement: createCustomIndexSlice,
  selectAnalyzer: selectAnalyzerSlice,
  ui: uiSlice,
  reproduction: reproductionSlice,
  analytics: analyticsSlice,
  communicationExplorer: communicationExplorerSlice,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === 'auth/logout') {
    const preservedPrevPage = state?.analytics?.prevPage;
    storage.removeItem('persist:root');
    state = undefined;
    const nextState = appReducer(state, action);

    if (!preservedPrevPage) {
      return nextState;
    }

    return {
      ...nextState,
      analytics: {
        ...nextState.analytics,
        prevPage: preservedPrevPage,
      },
    };
  }
  return appReducer(state, action);
};

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(signalRMiddleware),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
